export const DEFAULT_LOCALE = "th-TH"

/** Dictionaries / backend codes we still keep. zh-CN is deferred — see zh-cn-roadmap.ts */
export const SUPPORTED_LOCALES = ["th-TH", "my-MM", "en-US"] as const

/**
 * Locales shown in the language switcher.
 * my-MM is hidden until catalog + UI copy are complete.
 */
export const PICKER_LOCALES = ["th-TH", "en-US"] as const

export type AppLocale = (typeof SUPPORTED_LOCALES)[number]
export type PickerLocale = (typeof PICKER_LOCALES)[number]

export function isPickerLocale(locale: string | null | undefined): boolean {
  if (!locale) {
    return false
  }
  const trimmed = locale.trim().toLowerCase()
  return PICKER_LOCALES.some((code) => code.toLowerCase() === trimmed)
}

/** Map a stored/requested locale onto one the storefront picker currently offers. */
export function toPickerLocale(
  locale: string | null | undefined
): PickerLocale {
  const normalized = normalizeLocale(locale)
  return normalized === "en-US" ? "en-US" : DEFAULT_LOCALE
}

export function normalizeLocale(locale: string | null | undefined): AppLocale {
  if (!locale) {
    return DEFAULT_LOCALE
  }
  const trimmed = locale.trim()
  const exact = SUPPORTED_LOCALES.find(
    (code) => code.toLowerCase() === trimmed.toLowerCase()
  )
  if (exact) {
    return exact
  }
  const lang = trimmed.split(/[-_]/)[0]?.toLowerCase()
  if (lang === "my" || lang === "bur") {
    return "my-MM"
  }
  if (lang === "en") {
    return "en-US"
  }
  if (lang === "th") {
    return "th-TH"
  }
  return DEFAULT_LOCALE
}
